import { Platform } from "react-native";

/**
 * Web hover motion is decorative only. Pressed opacity/scale stays outside
 * these transitions so taps and clicks always acknowledge immediately.
 */
export const webControlHoverTransition = Platform.select({
  web: {
    transitionDuration: "160ms",
    transitionProperty: "background-color, border-color",
    transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
  } as object,
  default: undefined
});

/** Opacity companion for a dedicated hover-light layer. */
export const webControlHoverFadeTransition = Platform.select({
  web: {
    transitionDuration: "160ms",
    transitionProperty: "opacity",
    transitionTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)"
  } as object,
  default: undefined
});

/** Dense rows should acknowledge the pointer without feeling animated. */
export const webDenseHoverTransition = Platform.select({
  web: {
    transitionDuration: "120ms",
    transitionProperty: "background-color, border-color",
    transitionTimingFunction: "cubic-bezier(0.2, 0.8, 0.2, 1)"
  } as object,
  default: undefined
});

/**
 * Keep a touch that starts on a real control owned by that control. This is
 * intentionally web-only and does not consume wheel/trackpad scrolling, so
 * desktop can still scroll the surrounding stage while the pointer is over a
 * button. On iPad Safari it prevents the stage scroller from winning the
 * gesture before Pressable can deliver the tap.
 */
export const webTouchControl = Platform.select({
  web: {
    touchAction: "none"
  } as object,
  default: undefined
});

/**
 * A web video surface owns coarse-pointer drags so iPad Safari cannot promote
 * a control tap into scrolling the surrounding dance list. CSS touch-action
 * does not consume mouse-wheel or trackpad-wheel input, so desktop retains the
 * intentional scroll-through-player behavior.
 */
export const webTouchPlayerSurface = Platform.select({
  web: {
    touchAction: "none"
  } as object,
  default: undefined
});
